import { Box } from 'roo-ui/components';
import { TRAVEL_REQUIREMENTS_URL } from 'config/constants';
import { RedLink, TextP } from '../../primitives';

const TravelDocumentationReminder = () => (
  <Box my={2}>
    <TextP color="#555" fontWeight="bold" my={0}>
      Before you travel, please check the latest government requirements.
    </TextP>
    <TextP color="#555" fontWeight="bold" my={0}>
      Some Australian states and territories have introduced new measures, including additional health and safety protocols, in response to
      Coronavirus.
    </TextP>
    <RedLink label="View travel requirements" url={TRAVEL_REQUIREMENTS_URL} />
  </Box>
);

export default TravelDocumentationReminder;
